// src/auth/LoginPage.tsx
import { FormEvent, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useLogin } from './useAuth'

export function LoginPage() {
  const navigate = useNavigate()
  const login = useLogin()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  async function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault()
    try {
      await login.mutateAsync({ email, password })
      navigate('/')
    } catch {
      // l'erreur est lue via login.error
    }
  }

  return (
    <div style={{
      minHeight: '100vh',
      background: 'var(--bg)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '1.5rem',
    }}>
      <div style={{
        width: '100%',
        maxWidth: '380px',
      }}>
        <div style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '48px',
            height: '48px',
            borderRadius: '12px',
            background: 'var(--arancio)',
            marginBottom: '1.25rem',
          }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M12 3L20 7.5V16.5L12 21L4 16.5V7.5L12 3Z" fill="white" fillOpacity="0.9" />
            </svg>
          </div>
          <p style={{
            fontSize: '1rem',
            fontWeight: 600,
            color: 'var(--muted)',
            margin: 0,
            letterSpacing: '-0.01em',
          }}>
            OTIA Admin
          </p>
          <h1 style={{
            fontSize: '1.375rem',
            fontWeight: 600,
            color: 'var(--fg)',
            margin: '0.25rem 0 0',
            letterSpacing: '-0.02em',
          }}>
            Connexion
          </h1>
        </div>

        <form
          onSubmit={handleSubmit}
          style={{
            background: 'var(--surface)',
            border: '1px solid var(--line)',
            borderRadius: '16px',
            padding: '1.75rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
          }}
        >
          {login.error && (
            <div
              role="alert"
              style={{
              background: 'rgba(217,83,30,0.12)',
              border: '1px solid rgba(217,83,30,0.30)',
              borderRadius: '8px',
              padding: '0.625rem 0.875rem',
              fontSize: '0.8125rem',
              color: 'var(--arancio)',
            }}>
              {login.error.message}
            </div>
          )}

          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.375rem' }}>
            <label htmlFor="email" style={{ fontSize: '0.8125rem', color: 'var(--muted)', fontWeight: 500 }}>
              Adresse e-mail
            </label>
            <input
              id="email"
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="vous@exemple.com"
              style={{
                background: 'var(--elevated)',
                border: '1px solid var(--line)',
                borderRadius: '8px',
                padding: '0.625rem 0.875rem',
                color: 'var(--fg)',
                fontSize: '0.9375rem',
                outline: 'none',
                transition: 'border-color 0.15s',
                fontFamily: 'inherit',
              }}
              onFocus={(e) => { e.currentTarget.style.borderColor = 'var(--arancio)' }}
              onBlur={(e) => { e.currentTarget.style.borderColor = 'var(--line)' }}
            />
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.375rem' }}>
            <label htmlFor="password" style={{ fontSize: '0.8125rem', color: 'var(--muted)', fontWeight: 500 }}>
              Mot de passe
            </label>
            <input
              id="password"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              style={{
                background: 'var(--elevated)',
                border: '1px solid var(--line)',
                borderRadius: '8px',
                padding: '0.625rem 0.875rem',
                color: 'var(--fg)',
                fontSize: '0.9375rem',
                outline: 'none',
                transition: 'border-color 0.15s',
                fontFamily: 'inherit',
              }}
              onFocus={(e) => { e.currentTarget.style.borderColor = 'var(--arancio)' }}
              onBlur={(e) => { e.currentTarget.style.borderColor = 'var(--line)' }}
            />
          </div>

          <button
            type="submit"
            disabled={login.isPending}
            style={{
              marginTop: '0.5rem',
              background: login.isPending ? 'var(--arancio-deep)' : 'var(--arancio)',
              color: '#fff',
              border: 'none',
              borderRadius: '8px',
              padding: '0.6875rem 1rem',
              fontSize: '0.9375rem',
              fontWeight: 600,
              cursor: login.isPending ? 'not-allowed' : 'pointer',
              transition: 'background 0.15s',
              fontFamily: 'inherit',
              letterSpacing: '-0.01em',
            }}
          >
            {login.isPending ? 'Connexion…' : 'Se connecter'}
          </button>
        </form>
      </div>
    </div>
  )
}
